<script>
    import * as d3 from "d3";
    import * as hagrid from "@saehrimnir/hagrid";

    import { getScales } from "../utils.js";
    import { morph_d, morph_c, morph_xy } from "../custom_actions.js";

    export let level = 1;
    export let W = 100;
    export let H = 100;
    export let M = 20;
    export let strokeWidth = 2;
    export let radius = 5;
    export let numbers = true;

    $: hilbert_size = 2 ** level;
    $: hilbert_length = hilbert_size ** 2;
    $: hilbert_color_scale = d3.scaleSequential(d3.interpolateWarm).domain([0, hilbert_length])
    $: hilbert_curve = d3.range(0, hilbert_length).map(i => hagrid.hilbert_decode(i, hilbert_size));
    $: scales = getScales(hilbert_curve, [[M, W - M], [M, H - M]], true);
    $: scaled_hilbert_curve = hilbert_curve.map(([px, py]) => [scales.x(px), scales.y(py)]);
</script>

<svg width={W} height={H}>
    <g text-anchor="middle" dominant-baseline="central">
        {#each d3.pairs(scaled_hilbert_curve) as d, i}
            <path use:morph_d={{points: d}} fill="none" stroke={hilbert_color_scale(i + .5)} stroke-width={strokeWidth} />
        {/each}
        {#each scaled_hilbert_curve as d, i}
            <circle use:morph_c={{point: d}} r={radius} fill={hilbert_color_scale(i + .5)} />
            {#if numbers}
                <text 
                    fill="white"
                    use:morph_xy={{pos: d.map(v => v - 10)}}
                    font-size=0.33em>
                    {i}
                </text>
            {/if}
        {/each}
    </g>
</svg>